import type { WorkflowSummary } from "../../api/content/workflowsApi";

/**
 * A Workflow's name as the server compares names (`workflow_offers.workflow_name_key`, workflow-names
 * WN-1): without regard to case and runs of spaces. The server decides; this only says beforehand
 * what a save will do.
 */
function nameKey(name: string): string {
  return name.split(/\s+/u).filter((word) => word !== "").join(" ").toLowerCase();
}

/**
 * The Workflow a save under `name` continues (WN-4): one of `offered`, the project's listing,
 * which offers one Workflow per name, its own before a library's. `null` when no Workflow holds
 * the name, so the save adds a new one.
 */
export function heldWorkflow(offered: readonly WorkflowSummary[], name: string): WorkflowSummary | null {
  const key = nameKey(name);
  return key === "" ? null : (offered.find((workflow) => nameKey(workflow.name) === key) ?? null);
}
